export * from './GiftPageHero'
